export const TABLE_LOAD_INITIAL_PAGINATION = {
  page: 1,
}
